import { Container, TextInput, PasswordInput, Button, Title } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'
import config from "../config";


export function LoginPage() {
    const { login } = useAuth()
    const navigate = useNavigate()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const handleLogin = async () => {
        try {
            const response = await axios.post(`${config.BASE_URL}/auth/login`, {
                email,
                password,
            })

            const { accessToken, refreshToken } = response.data

            localStorage.setItem('accessToken', accessToken)
            localStorage.setItem('refreshToken', refreshToken)

            login()
            navigate('/admin')
        } catch (error) {
            toast.error('Login failed. Please check your credentials.')
            console.error('Login error:', error)
        }
    }

    return (
        <Container size="xs" mt="xl">
            <Title mb="lg">Admin Login</Title>
            <TextInput
                label="Email"
                placeholder="admin@admin.com"
                required
                value={email}
                onChange={(event) => setEmail(event.currentTarget.value)}
            />
            <PasswordInput
                label="Password"
                placeholder="••••••"
                required
                value={password}
                onChange={(event) => setPassword(event.currentTarget.value)}
            />
            <Button fullWidth mt="md" onClick={handleLogin}>
                Login
            </Button>
        </Container>
    )
}
